import focus from './focus';
import error from './error';

export default {
  focus,
  error,
};
